import { get } from "lodash";

import { BusinessResource } from "@skinsoft/types/api/business-resource";

export const type = (businessResource: BusinessResource): string | undefined | null => {
    return get(businessResource, "type") ??
        get(businessResource, "entityType") ??
        get(businessResource, "favType") 
}